module.exports = __webpack_public_path__ + "static/media/do4.1e108250.png";